export default __webpack_public_path__ + "static/media/Image 1.724de6f3.png";